import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// UI
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    avatar: {
      border: '2px solid #fff',
      width: 40,
      height: 40,
      marginRight: theme.spacing(),
    },
  };
};

// Component
class PersonListItem extends PureComponent {
  static propTypes = {
    person: PropTypes.object.isRequired,
    secondaryAction: PropTypes.node,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
  };

  render() {
    const { person, secondaryAction, classes, ...otherProps } = this.props;

    return (
      <ListItem button {...otherProps}>
        <Avatar alt={person.displayName} className={classes.avatar} src={`${person.pictureUrl}`} />
        <ListItemText primary={person.displayName} secondary={person.title} />
        {secondaryAction}
      </ListItem>
    );
  }
}

export default withStyles(styles)(PersonListItem);
